import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as c from '../constant';
import * as actions from '../action';

function DeactivateModal({ id, data, deactivating, deactivateCitizen, showSeniorCitizentList }) {
  const [formData, setFormData] = useState({
    has_mortuary_aid: 0,
  });
  const setModal = useContext(ModalContext);

  useEffect(() => {
    setFormData({
      has_mortuary_aid: _.get(data, 'attributes.has_mortuary_aid'),
    })
  }, [])

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      has_mortuary_aid: _.get(formData, 'has_mortuary_aid') ? 1 : 0 
    }

    deactivateCitizen(id, args, () => {
      setModal({ isOpen: false });
      showSeniorCitizentList(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked,
    });
  }

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Are you sure, you want to {_.get(data, 'attributes.is_active') ? 'Deactivate' : 'Activate'} this citizen?
            </label>
          </div>
          <div className='col-12 form-group pt-2 mb-0'>
            <input
              name="has_mortuary_aid"
              type="checkbox"
              checked={_.get(formData, 'has_mortuary_aid') || 0}
              onChange={onChange}
            />
            <label htmlFor="last_name" className="form-label font-weight-bold ml-2">
              Will Avail Mortuary Aid?
            </label>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
            disabled={deactivating}
          >
            <span className="font-weight-bold">
              {/* eslint-disable */}
              {deactivating ? (
                <i className="fa fa-spin fa-spinner" />
              ) : (
                `Confirm`
              )}
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

DeactivateModal.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  deactivateCitizen: PropTypes.instanceOf(Function).isRequired,
  deactivating: PropTypes.bool.isRequired,
  showSeniorCitizentList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  deactivating: api.loading.indexOf(c.DEACTIVATE_CITIZEN) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(DeactivateModal);
